import FaqRoute from "./faq.js";

// Guidelines is a faq alias
export default class GuidelinesRoute extends FaqRoute {
  pageId = "guidelines";
}
